import { Component, Input, OnInit, ViewChild } from "@angular/core";
import {
  ControlValueAccessor,
  FormControl,
  NgControl,
} from "@angular/forms";
import { format } from "rut.js";
import { Util } from '../../common/utils/util';
import { IonInput } from "@ionic/angular";

@Component({
    selector: "app-outline-input",
    templateUrl: "./outline-input.component.html",
    styleUrls: ["./outline-input.component.scss"],
    standalone: false
})
export class OutlineInputComponent implements OnInit, ControlValueAccessor {
  // Input
  @Input()
  set type(value: string) {
    this.originalType = value;
    this.tempType = value;
  }

  originalType: string = "text";
  tempType: string = "text";

  @Input() placeholder: string;
  @Input() autocomplete: string = "off";
  @Input() maxlength: number = 3;
  @Input() minlength: number = 0;
  @Input() isPassword: boolean = true;
  @Input() mask: string;
  @Input() prefix: string;
  // Label
  @Input() label: string;
  @Input() labelStacked: boolean = false;
  @Input() rutFormat: boolean = false;

  // Error Message
  @Input() errorMessage: string;
  @Input() valueFinal:string;

  @Input()
  set value(value: string | number) {
    this.valueAux = value && this.originalType === "rut" ? format(value.toString(), {dots: true}) : value;
  }

  @Input() isDisabled: boolean;
  @ViewChild('key') inputElement: IonInput;

  get value(): string | number {
    return this.valueAux;
  }

  private valueAux: string | number;

  public get formControl(): FormControl {
    return this.control.control as FormControl;
  }

  
  public isFocus: boolean = false;
  public isDirty: boolean = false;
  get hasValue(): boolean {
    return (
      this.value != null && this.value != "" && this.value != undefined
    );
  }

  propagateChange = (_: any) => { };

  constructor(
    public control: NgControl,
    public utils: Util
    ) {
    if (control) control.valueAccessor = this;
  }

  ngOnInit() {
    this.formControl.markAsUntouched();
  }

  onChange(value: string | number) {
    this.isDirty = true;
    if(this.rutFormat) this.formatRut(String(value));
    else{
      this.value = value;
      this.propagateChange(this.value);
    }
  }

  validatePercentageInput(event: any) {
    let inputValue = event.target.value.replaceAll(/\D/g, '');
    inputValue = inputValue.replace(/^0+/, '');
    if (inputValue > 100) {
      this.value = 100
    } else this.value= inputValue;
    event.target.value = this.value;
  }

  formatRut(value:string) {
    if (value.length > 2 || (value.length === 2 && !value.includes('-'))) {
      value = format(value);
    } else if (value.length === 2 && value.includes('-')) {
      value = value.replace('-', '');
    }

    this.value = value;
    this.propagateChange(this.value);
  }

  onFocus() {
    this.control.reset();
    this.isFocus = true;
    this.inputElement.setFocus();
  }

  onBlur() {
    this.formControl.markAsTouched();
    this.isFocus = false;
  }

  cleanInput() {
    this.value = "";
    this.propagateChange(this.value);  
  }

  writeValue(value: string | number): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(): void {
    // Metodo requerido por ControlValueAccessor  
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }
}
